import { Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import {
    JobStatusTypeMap,
    jobStatusColorTypeMap
} from '../../Pages/AdminPage/FiltersView/ExportFiltersView/ExportFiltersTable';

export default function JobStatus({ value }: { value: JobStatusTypeMap }) {
    const { t } = useTranslation('admin');

    return <Badge status={jobStatusColorTypeMap[value]} text={t(`exportFilter.statusMap.${value?.toString()}`)} />;
}
